import { FontEntry } from '../../types/font'

export const tomorrow: FontEntry = {
  displayName: 'Tomorrow',
  weights: {
    300: {
      normal: { file: 'Tomorrow-Light', extension: 'ttf', format: 'truetype' },
      italic: null
    },
    400: {
      normal: { file: 'Tomorrow-Regular', extension: 'ttf', format: 'truetype' },
      italic: null
    }
  },
  fallbackMetrics: {
    arial: {
      regular: {
        sizeAdjust: 106.27,
        ascentOverride: 94.1,
        descentOverride: 18.82,
        lineGapOverride: 0
      },
      bold: {
        sizeAdjust: 99.42,
        ascentOverride: 100.59,
        descentOverride: 20.12,
        lineGapOverride: 0
      }
    },
    roboto: {
      regular: {
        sizeAdjust: 107.83,
        ascentOverride: 92.74,
        descentOverride: 18.55,
        lineGapOverride: 0
      },
      bold: {
        sizeAdjust: 105.33,
        ascentOverride: 94.94,
        descentOverride: 18.99,
        lineGapOverride: 0
      }
    }
  }
}
